module.exports = __webpack_public_path__ + "static/media/19ESCAP15.178d1ee1.jpg";